var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product__image-carousel" }, [
    _c(
      "div",
      { staticClass: "product__image-carousel-main" },
      [
        _c(
          "swiper",
          {
            ref: "imageCarouselSwiper",
            attrs: { options: _vm.swiperOption },
            on: {
              slideChange: function($event) {
                return _vm.slideChanged()
              }
            }
          },
          [
            _vm._l(_vm.images, function(image) {
              return _c("swiper-slide", { key: image.id }, [
                _c(
                  "div",
                  { staticClass: "product__image-carousel__image-container" },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: image.urls.large || image.urls.full,
                          expression: "image.urls.large || image.urls.full"
                        }
                      ],
                      staticClass: "product__image-carousel__image",
                      attrs: { srcset: image.srcset, alt: "" },
                      on: {
                        click: function($event) {
                          return _vm.toggleFullScreenMode()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "product__image-carousel__zoom-button",
                        on: {
                          click: function($event) {
                            return _vm.toggleFullScreenMode()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "screen-reader-text" }, [
                          _vm._v("Avaa suurempana")
                        ])
                      ]
                    )
                  ]
                )
              ])
            }),
            _vm._v(" "),
            _vm.images.length > 1
              ? _c("button", {
                  staticClass: "swiper-button-prev",
                  attrs: { slot: "button-prev" },
                  slot: "button-prev"
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.images.length > 1
              ? _c("button", {
                  staticClass: "swiper-button-next",
                  attrs: { slot: "button-next" },
                  slot: "button-next"
                })
              : _vm._e()
          ],
          2
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.images.length > 1
      ? _c(
          "div",
          { staticClass: "product__image-carousel-pagination" },
          [
            _c(
              "swiper",
              {
                ref: "paginationSwiper",
                attrs: { options: _vm.paginationSwiperOptions }
              },
              _vm._l(_vm.images, function(image, index) {
                return _c(
                  "swiper-slide",
                  {
                    key: image.id,
                    class: {
                      "active-pagination-slide":
                        index == _vm.activePaginationSlide
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "product__image-carousel-pagination__slide product__image-carousel__image-container"
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value: image.urls.mini,
                              expression: "image.urls.mini"
                            }
                          ],
                          staticClass: "product__image-carousel__image",
                          attrs: {
                            srcset:
                              image.urls.mini +
                              " 1x, " +
                              image.urls["mini-x2"] +
                              " 2x",
                            alt: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeSlide(index)
                            }
                          }
                        })
                      ]
                    )
                  ]
                )
              }),
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.fullScreenMode,
            expression: "fullScreenMode"
          }
        ],
        staticClass: "product-image-modal"
      },
      [
        _c(
          "div",
          { staticClass: "product-image-modal__content" },
          [
            _c(
              "swiper",
              {
                ref: "fullScreenSwiper",
                attrs: { options: _vm.swiperOption },
                on: {
                  slideChange: function($event) {
                    return _vm.slideChanged()
                  }
                }
              },
              [
                _vm._l(_vm.images, function(image) {
                  return _c("swiper-slide", { key: image.id }, [
                    _c(
                      "div",
                      {
                        staticClass: "product__image-carousel__image-container"
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "lazy",
                              rawName: "v-lazy",
                              value:
                                image.urls["fullscreen-med"] || image.urls.full,
                              expression:
                                "image.urls['fullscreen-med'] || image.urls.full"
                            }
                          ],
                          staticClass: "product-image-modal__image",
                          attrs: { srcset: image.srcset, alt: "" }
                        })
                      ]
                    )
                  ])
                }),
                _vm._v(" "),
                _vm.images.length > 1
                  ? _c("button", {
                      staticClass: "swiper-button-prev",
                      attrs: { slot: "button-prev" },
                      slot: "button-prev"
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.images.length > 1
                  ? _c("button", {
                      staticClass: "swiper-button-next",
                      attrs: { slot: "button-next" },
                      slot: "button-next"
                    })
                  : _vm._e()
              ],
              2
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "product-image-modal__close-button",
            on: {
              click: function($event) {
                return _vm.toggleFullScreenMode()
              }
            }
          },
          [
            _c(
              "span",
              { staticClass: "product-image-modal__close-button__text" },
              [_vm._v("Sulje")]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5999a670", { render: render, staticRenderFns: staticRenderFns })
  }
}